import { FeatureFlags } from '~src/commonInfra/featureFlags/FeatureFlags';
import { EntityActionNames, IEntityAction } from '~src/spacesPlatform/components/ActionsMenu/EntityActions/IEntityAction';
import { ILabelValueAction } from '~src/spacesPlatform/models/actionNames';
import { currentUserIsAdmin } from '~src/spacesPlatform/utils/MixedContentHelpers';

import { Messages } from '../../../codegen/Localize';
import { setCertificationOrTriggerWarningAction } from '../../actions/labels/SetCertificationOrTriggerWarningAction';
import { ILabelValueInfo } from '../../models/ILabelValueInfo';
import { selectCatalogingOnSiteEnabled } from '../../selectors/CatalogSelectors';

export const SetCertificationOrTriggerWarningLabelValueEntityAction: IEntityAction<ILabelValueInfo , ILabelValueAction> = {
    name: EntityActionNames.SetCertificationOrTriggerWarning,
    translateName: Messages.edit,
    isVisible: (items, state) => selectCatalogingOnSiteEnabled(state) && FeatureFlags.labelManagementEnabled
    && currentUserIsAdmin(state) && isCertificationOrTriggerWarning(items),
    isClickable: (_, targetItems, _state) => targetItems.length === 1,
    createReduxAction: (items) => {
        if (!items || items.length === 0 || items.length > 1) {
          throw new Error(Messages.setCertificationLabelValueError());
        }
        return setCertificationOrTriggerWarningAction(items[0]);
    }

};

function isCertificationOrTriggerWarning(items: ILabelValueInfo[]) {
    return items[0].category.toLowerCase() === 'certification' ||
    items[0].value.toLowerCase() === 'extract_refresh_failure' ||
    items[0].value.toLowerCase() === 'flow_run_failure';
}